export default function initNavigation() {
    const $container = document.querySelector('.navigation-container');
    if(!$container.classList.contains("clickable")) {
        const $toggle = $container.querySelectorAll('li.has-submenu a.has-submenu:not(.is-actual)');
        $toggle.forEach($link => {
            $link.addEventListener('click', event => {
                event.preventDefault();
                event.target.classList.toggle('is-open');
                event.target.parentNode.classList.toggle('is-open');
                event.target.parentNode.parentNode.classList.toggle("is-open");
            });
        });
    }
}
